// extracted by mini-css-extract-plugin
export default {"endorsementContainer":"Endorsements__endorsementContainer___vL3mu","carousel":"Endorsements__carousel___JuLQ8","endorsement":"Endorsements__endorsement___gjfpR"};